import React from "react";
import { Helmet } from "react-helmet-async";

export function SEO({ title, description, ogImage, canonicalUrl }) {
  const defaultTitle = "Kokholm Byg";
  const fullTitle = title
    ? (title.includes("Kokholm Byg") ? title : `${title} - Kokholm Byg`)
    : defaultTitle;

  const defaultDescription = "Kokholm Byg er dit professionelle murer- og byggefirma i Holstebro med mere end 30 års erfaring inden for flisearbejde, badeværelsesrenovering, reparationer, tilbygninger og nybyggeri.";
  const metaDesc = description || defaultDescription;
  const image = ogImage || "https://assets.auxodev.dk/assets/2f17f913-822d-430f-9ea1-0cc9e6665c42/kokholm-logo.png";
  const canonical = canonicalUrl || (typeof window !== "undefined" ? window.location.href : "");

  return (
    <Helmet>
      <html lang="da" />
      <title>{fullTitle}</title>
      <meta name="description" content={metaDesc} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDesc} />
      <meta property="og:image" content={image} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDesc} />
      <meta name="twitter:image" content={image} />
      {canonical && <link rel="canonical" href={canonical} />}
    </Helmet>
  );
}
